<i18n src="../../locales/lang.json"></i18n>
<template>
  
  <div class="container-fluid upload-container p-3">
    <div class="row mt-0" v-show="viewtype == 'adduserschedule' && locationshiftid.length == 0">
      <div class="custom-form-main-label">
        {{$t('view_user_schedule')}}
      </div>
    </div>
    <div class="row mt-3" v-show="viewtype == 'adduserschedule'">
      <div class="col-sm-12 px-0">
        <!--<select required class="form-control" v-bind:id="'select_assigned_user_' +  getId()" v-on:change="onChange" v-select>
          <option value="selectall" style="">{{$t('select_user_all')}}</option>
          <option v-for="user in users" v-bind:value="user.UserName">
            {{ user.Name }}
          </option>
        </select>-->

        <select class="form-control" v-bind:id="'select_assigned_user_' +  getId()" v-on:change="onChange">
          <option value="selectall" style="">{{$t('select_user_all')}}</option>
          <option v-for="user in users" v-bind:value="user.UserName">
            {{ user.Name }}
          </option>
        </select>


      </div>
    </div>
    <div class="form-group row mt-3" v-show="viewtype == 'adduserschedule' && locationshiftid.length > 0">
      <div class="col-lg-12">
        <button @click="saveSchedule" type="button" class="btn skin btn-primary pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
        <button @click="cancelSchedule" type="button" class="btn pull-right mr-2"><i class="icon-cog5 mr-2"></i> {{$t('cancel')}}</button>
      </div>
    </div>
    <div class="container-fluid p-0 mt-3" v-show="locationshiftid.length>0 && selecteduser == 'selectall'">
      <div class="row mt-0">
        <div class="custom-form-main-label">
          {{locUserSchModel.locationname}}, {{locUserSchModel.day}} {{locUserSchModel.date}} {{locUserSchModel.siteShift}} {{locUserSchModel.startTime}}-{{locUserSchModel.endTime}}
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12 px-0">
          <select class="form-control" v-bind:id="'select_user_' +  getId()">
            <option value="" style="">{{$t('select_user')}}</option>
            <option v-for="user in users" v-bind:value="user.UserName">
              {{ user.Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group row mt-3">
        <div class="col-lg-12">
          <button @click="addUserSchedule" type="button" class="btn skin btn-primary pull-right"><i class="icon-cog5 mr-2"></i> {{$t('add_user')}}</button>
          <!--<button @click="clearSelection" type="button" class="btn pull-right mr-2"><i class="icon-cog5 mr-2"></i> {{$t('cancel')}}</button>-->
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12 px-0 custom-form-main-label mb-2">
          {{$t('scheduled_users')}}
        </div>
        <div class="col-sm-12 px-0" v-for="user in locUserSchModel.users">
          {{ user.Name }}
          <i @click="deleteUserSch(user.Id)" class="icon-cross2 text-danger-400 pl-2 cursor-pointer"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var users = [];

  var date = [];
  var locationshiftid = [];
  var viewtype = 'adduserschedule';
  export default {
    name: "userlist-dropdown-schedule",
    components: {

    },
    props: {

    },
    data() {
      return {
        users,
        locationshiftid: [],
        viewtype: 'adduserschedule',
        date: [],
        sdate: '',
        edate: '',
        selecteduser: 'selectall',
        locUserSchModel: { locationname: '', day: '', date: '', users: [], siteShift: '', startTime: '', endTime: '' },
      };
    },
    methods: {

      onChange() {        
        this.locationshiftid = [];
        //if (this.viewtype == 'viewuserschedule') {
        //this.$emit('event-change-member', $('#select_assigned_user_' + this.getId()).val());
        //this.$emit('change', $('#select_assigned_user_' + this.getId()).val());
        this.setOverride($('#select_assigned_user_' + this.getId()).val());
        //}
      },
      firstTimeLoad() {
        var users = '';
        //this.users.forEach((value, index) => {
        //  value.IsSchedule = true;
        //  users = users == '' ? value.Email : users + ',' + value.Email;
        //});
        //this.$forceUpdate();

        var obj = {
          tab: "UserScheduleAdmin", action: "adduserschedule", subaction: "getschedule", data: users
        };

        var data = JSON.stringify(obj);
        vm.$root.$emit('refreshview', data);
      },

      setOverride(val) {
        this.selecteduser = val;
        var users = '';
        if (val === "selectall") {
          //this.users.forEach((value, index) => {
          //  users = users == '' ? value.Email : users + ',' + value.Email;
          //});
        } else {
          users = val;
        }
        
        var obj = {
          tab: "UserScheduleAdmin", action: "adduserschedule", subaction: "getschedule", data: users
        };
        var data = JSON.stringify(obj);
        vm.$root.$emit('refreshview', data);

      },
      getId() {
        return this._uid;
      },
      loadMembers() {
        try {
          var url = '/api/Users/v1';
          this.$http.get(url).then(async response => {
            this.users = response.data;
            if (this.users !== null && this.users.length > 0) {
              this.users = this.users.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            $('#select_assigned_user_' + this.getId()).select2();
            $('#select_user_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      setData(locationshiftid, viewtype, sdate, edate) {
        //this.date = date;
        this.locationshiftid = locationshiftid;
        this.viewtype = viewtype;
        this.sdate = sdate;
        this.edate = edate;
        //$('#select_assigned_user_' + this.getId()).val('selectall');
        //$('#select_assigned_user_' + this.getId()).trigger('change');
        this.$forceUpdate();

        if (this.selecteduser === 'selectall' && this.locationshiftid.length > 0) {
          this.getLocationUserSchedule(this.locationshiftid[0]);
        }
       

      },
      clearSelection() {

        //$('#select_assigned_user_' + this.getId()).val('selectall');
        //$('#select_assigned_user_' + this.getId()).trigger('change');
        //this.users.forEach((value, index) => {

        //  value.IsSchedule = false;
        //});
        this.locationshiftid = [];
        this.viewtype = 'adduserschedule';
        this.selecteduser = 'selectall';
        var thisContext = this;
        setTimeout(function () {
          $('#select_assigned_user_' + thisContext.getId()).val('selectall');
          $('#select_assigned_user_' + thisContext.getId()).trigger('change');
        }, 100);
        

        this.$forceUpdate();

      },
      cancelSchedule() {
        this.clearSelection();
        //$('#select_assigned_user_' + this.getId()).val('selectall');
        //$('#select_assigned_user_' + this.getId()).trigger('change');
        var obj = {
          tab: "UserScheduleAdmin", action: "canceluserschedule"
        };
        var data = JSON.stringify(obj);
        vm.$root.$emit('refreshview', data);
      },
      async saveSchedule() {
        //if (this.locationshiftid.length == 0) return;
        var val = $('#select_assigned_user_' + this.getId()).val();
        var users = [];
        if (val === "selectall") {
          this.users.forEach((value, index) => {
            users.push(value.Username);
          });
        } else {
          users.push(val);
        }
        var request = {
          users: users, locationshiftIds: this.locationshiftid, startDate: this.sdate, endDate: this.edate
        };

        try {
          var response = await this.$http.post(
            '/api/Admin/v1/Users/Schedule/Save',
            request
          ).then(async response => {
            this.clearSelection();
            //vm.$root.$emit('procedure_editor_can_close');
            this.setOverride($('#select_assigned_user_' + this.getId()).val());
          })

        } catch (err) {
          //alert(err);
          //handleClientException(err.response.status === 401);
        }
      },
      async addUserSchedule() {
        var user = $('#select_user_' + this.getId()).val();
        if (user !== '') {
          var url = '/api/Admin/v1/Users/Schedule/Add?locshiftIdWithday=' + this.locationshiftid[0] + '&user=' + user;
          this.$http.get(url).then(async response => {
            this.getLocationUserSchedule(this.locationshiftid[0]);
            this.setOverride($('#select_assigned_user_' + this.getId()).val());
          });
        }
      },
      async getLocationUserSchedule(id) {
        try {
          var url = '/api/Admin/v1/Users/Location/Schedule?locshiftIdWithday=' + id;
          this.$http.get(url).then(async response => {
            console.log(response.data);
            this.locUserSchModel = response.data;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async deleteUserSch(id) {
        try {
          var url = '/api/Admin/v1/Users/Schedule?id=' + id;
          this.$http.delete(url).then(async response => {
            this.getLocationUserSchedule(this.locationshiftid[0]);
            this.setOverride($('#select_assigned_user_' + this.getId()).val());
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },

    },
    watch: {
    },
    mounted() {
      this.loadMembers();
      $("#select_assigned_user_" + this.getId()).change(this.onChange);
    }
  };
</script>

<style scoped>
  /*.select_container {
    width: calc(100% - 50px)
  }*/

</style>




// WEBPACK FOOTER //
// src/components/scheduling/userlist-dropdown-schedule.vue